// source: dbUserInfo.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.common.model.DbUserInfo', null, global);
goog.exportSymbol('proto.common.model.DbUserList', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.model.DbUserInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.common.model.DbUserInfo.repeatedFields_, null);
};
goog.inherits(proto.common.model.DbUserInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.model.DbUserInfo.displayName = 'proto.common.model.DbUserInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.model.DbUserList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.common.model.DbUserList.repeatedFields_, null);
};
goog.inherits(proto.common.model.DbUserList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.model.DbUserList.displayName = 'proto.common.model.DbUserList';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.common.model.DbUserInfo.repeatedFields_ = [8,9,10,11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.model.DbUserInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.common.model.DbUserInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.model.DbUserInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.DbUserInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
uid: jspb.Message.getFieldWithDefault(msg, 1, ""),
phone: jspb.Message.getFieldWithDefault(msg, 2, 0),
password: jspb.Message.getFieldWithDefault(msg, 3, ""),
googlesecret: jspb.Message.getFieldWithDefault(msg, 4, ""),
role: jspb.Message.getFieldWithDefault(msg, 5, ""),
creator: jspb.Message.getFieldWithDefault(msg, 6, ""),
createms: jspb.Message.getFieldWithDefault(msg, 7, 0),
iplistList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
macaddrlistList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
baniplistList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
banmacaddrlistList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
isadmin: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
deleted: jspb.Message.getBooleanFieldWithDefault(msg, 13, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.model.DbUserInfo}
 */
proto.common.model.DbUserInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.model.DbUserInfo;
  return proto.common.model.DbUserInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.model.DbUserInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.model.DbUserInfo}
 */
proto.common.model.DbUserInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPhone(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setGooglesecret(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreator(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatems(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addIplist(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addMacaddrlist(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addBaniplist(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.addBanmacaddrlist(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsadmin(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.model.DbUserInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.model.DbUserInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.model.DbUserInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.DbUserInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPhone();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getGooglesecret();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreator();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCreatems();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getIplistList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getMacaddrlistList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getBaniplistList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getBanmacaddrlistList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      11,
      f
    );
  }
  f = message.getIsadmin();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getDeleted();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
};


/**
 * optional string uid = 1;
 * @return {string}
 */
proto.common.model.DbUserInfo.prototype.getUid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.setUid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 phone = 2;
 * @return {number}
 */
proto.common.model.DbUserInfo.prototype.getPhone = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.setPhone = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string password = 3;
 * @return {string}
 */
proto.common.model.DbUserInfo.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string googleSecret = 4;
 * @return {string}
 */
proto.common.model.DbUserInfo.prototype.getGooglesecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.setGooglesecret = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string role = 5;
 * @return {string}
 */
proto.common.model.DbUserInfo.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string creator = 6;
 * @return {string}
 */
proto.common.model.DbUserInfo.prototype.getCreator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.setCreator = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 createMs = 7;
 * @return {number}
 */
proto.common.model.DbUserInfo.prototype.getCreatems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.setCreatems = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * repeated string ipList = 8;
 * @return {!Array<string>}
 */
proto.common.model.DbUserInfo.prototype.getIplistList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.setIplistList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.addIplist = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.clearIplistList = function() {
  return this.setIplistList([]);
};


/**
 * repeated string macAddrList = 9;
 * @return {!Array<string>}
 */
proto.common.model.DbUserInfo.prototype.getMacaddrlistList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.setMacaddrlistList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.addMacaddrlist = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.clearMacaddrlistList = function() {
  return this.setMacaddrlistList([]);
};


/**
 * repeated string banIpList = 10;
 * @return {!Array<string>}
 */
proto.common.model.DbUserInfo.prototype.getBaniplistList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.setBaniplistList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.addBaniplist = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.clearBaniplistList = function() {
  return this.setBaniplistList([]);
};


/**
 * repeated string banMacAddrList = 11;
 * @return {!Array<string>}
 */
proto.common.model.DbUserInfo.prototype.getBanmacaddrlistList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.setBanmacaddrlistList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.addBanmacaddrlist = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.clearBanmacaddrlistList = function() {
  return this.setBanmacaddrlistList([]);
};


/**
 * optional bool isAdmin = 12;
 * @return {boolean}
 */
proto.common.model.DbUserInfo.prototype.getIsadmin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.setIsadmin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool deleted = 13;
 * @return {boolean}
 */
proto.common.model.DbUserInfo.prototype.getDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.model.DbUserInfo} returns this
 */
proto.common.model.DbUserInfo.prototype.setDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.common.model.DbUserList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.model.DbUserList.prototype.toObject = function(opt_includeInstance) {
  return proto.common.model.DbUserList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.model.DbUserList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.DbUserList.toObject = function(includeInstance, msg) {
  var f, obj = {
usersList: jspb.Message.toObjectList(msg.getUsersList(),
    proto.common.model.DbUserInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.model.DbUserList}
 */
proto.common.model.DbUserList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.model.DbUserList;
  return proto.common.model.DbUserList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.model.DbUserList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.model.DbUserList}
 */
proto.common.model.DbUserList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.common.model.DbUserInfo;
      reader.readMessage(value,proto.common.model.DbUserInfo.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.model.DbUserList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.model.DbUserList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.model.DbUserList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.DbUserList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.common.model.DbUserInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DbUserInfo users = 1;
 * @return {!Array<!proto.common.model.DbUserInfo>}
 */
proto.common.model.DbUserList.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.common.model.DbUserInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.common.model.DbUserInfo, 1));
};


/**
 * @param {!Array<!proto.common.model.DbUserInfo>} value
 * @return {!proto.common.model.DbUserList} returns this
*/
proto.common.model.DbUserList.prototype.setUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.common.model.DbUserInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.model.DbUserInfo}
 */
proto.common.model.DbUserList.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.common.model.DbUserInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.model.DbUserList} returns this
 */
proto.common.model.DbUserList.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};


goog.object.extend(exports, proto.common.model);
